import React, { useState } from "react";
import "./StudentCourseDetailSection.css";


// 画像は仮で同じものを使っています。必要に応じて差し替えてください。
import courseImg01 from "../assets/images/student/student-course-detail-image.jpeg";
import courseImg02 from "../assets/images/top/course-image-01.jpeg";
import courseImg03 from "../assets/images/top/course-image-02.jpeg";
import courseImg04 from "../assets/images/top/course-image-03.jpeg";
import courseImg05 from "../assets/images/top/course-image-04.jpeg";
import courseImg06 from "../assets/images/top/course-image-06.jpeg";

const COURSES = [
  {
    key: "genai",
    label: "生成AIマスター",
    tint: "#06b6d4",            // タブのアイコン背景色（シアン）
    icon: "spark",
    title: "生成AIマスター",
    img: courseImg01,             // 画像が用意できたら差し替え可
    summary:
      "ChatGPT や Gamma などの生成AIを使いこなし、資料作成・スプレッドシート処理・GASによる業務自動化などを実践的に学びます。さらに、興味に応じてデータ分析やWeb制作の基礎も追加で学習し、仕事に直結する“使えるスキル”を身につけます。",
    skills: [
      "ChatGPT/Claude",
      "Gamma",
      "プロンプト設計",
      "Google Sheets/Excel処理",
      "GAS自動化",
      "API/外部連携",
      "Zapier/Make",
      "情報整理/要約",
      "プレゼン資料作成"
    ],
    careers: [
      "AI活用スペシャリスト",
      "業務自動化（GAS）担当",
      "BizOps/バックオフィスDX",
      "マーケ/広報（資料・LP制作）",
      "データオペレーター（見習い）"
    ],
    features: [
      "生成AIを使ったドキュメント・プレゼン資料作成",
      "スプレッドシートの整形・集計・レポート自動生成",
      "GASでの定型業務の自動化（通知/集計/レポート）",
      "外部ツール連携（API・Zapier/Make）",
      "安全なAI活用・情報管理のベストプラクティス"
    ],
    point:
      "企業/自治体の“実務フロー”を題材に、ドキュメント化と自動化をセットで改善。成果物はそのまま職務経歴やポートフォリオとして提示できます。"
  },
  {
    key: "ai",
    label: "AI開発",
    tint: "#8b5cf6", // アイコン背景
    icon: "ai",
    title: "AI開発者",
    img: courseImg02,
    summary:
      "生成AIやMLモデルの開発・実装を通して、次世代のAIソリューションを創造するスペシャリストを目指します。",
    skills: ["Python", "PyTorch", "機械学習", "ディープラーニング", "LLM開発", "Transformers", "OpenAI API"],
    careers: ["AIエンジニア", "データサイエンティスト", "機械学習エンジニア", "AIプロダクトマネージャー"],
    features: [
      "最新の生成AI技術を習得",
      "機械学習モデルの構築・最適化",
      "自然言語処理の実装",
      "AIサービスの企画・開発"
    ],
    point:
      "実際の企業プロジェクトに参加し、リアルなポートフォリオを作成しながら学習することができます。"
  },
  {
    key: "data",
    label: "データサイエンス",
    tint: "#3b82f6",
    icon: "chart",
    title: "データサイエンティスト",
    img: courseImg03,
    summary:
      "機械学習とビッグデータ処理を用いて、事業の意思決定をリードできるデータサイエンティストを育成します。ETL/ELT、特徴量設計、学習・評価、効果検証、可視化・報告までを一気通貫で実践します。",
    skills: ["Python / SQL", "NumPy / Pandas",
    "scikit-learn / XGBoost / LightGBM",
    "BigQuery / Snowflake", "MLflow / Feature Store",
    "可視化(Plotly/BI)", "A/Bテスト・因果推論"],
    careers: ["データサイエンティスト",
    "機械学習エンジニア（分析基盤）",
    "アナリティクスエンジニア",
    "BI / データコンサルタント"],
    features: [
    "ETL/ELT とデータパイプライン構築",
    "Spark/BigQuery でのビッグデータ処理",
    "特徴量設計・学習・評価・ハイパラ最適化",
    "A/B テストと因果推論による効果検証",
    "ダッシュボード/レポートで意思決定を支援（MLOps基礎含む）"
    ],
    point: "企業データを題材に、収集→前処理→特徴量→学習→評価→可視化/報告までを E2E で構築。Notebook と MLflow で再現可能な成果物を残します。"
  },
  {
    key: "game",
    label: "ゲーム開発",
    tint: "#f59e0b",
    icon: "gamepad",
    title: "ゲームエンジニア",
    img: courseImg04,
    summary:
      "ゲームエンジンを用いた企画・実装・演出最適化まで、プレイヤー体験を重視した開発を学びます。",
    skills: ["Unity/UE", "C# / C++", "シェーダ", "ネットワーク", "演出最適化"],
    careers: ["ゲームプログラマ", "アプリエンジニア", "メタバースクリエイター"],
    features: [
    "トラック選択：Webアプリ or Unityネイティブ",
    "UI/UX設計・状態管理・API連携",
    "モバイル/タブレット最適化・ストア公開",
    "Unityでの入力・物理・アニメーション・ビルド"
    ],
    point: "チームで小規模タイトルを制作し、公開までを経験します。"
  },
  {
    key: "cg",
    label: "CG・アニメ",
    tint: "#ec4899",
    icon: "palette",
    title: "CG・アニメーター",
    img: courseImg05,
    summary:
      "モデリング・リギング・アニメーションを通して、映像/ゲーム向けアセット制作を実践します。",
    skills: ["Blender", "Maya", "ZBrush", "Substance", "レンダリング"],
    careers: ["3Dモデラ", "アニメーター", "テクスチャアーティスト"],
    features: ["キャラ/背景アセット制作", "レンダリングワークフロー", "アニメーション基礎〜応用", "最適化/書き出し"],
    point: "企業案件やアプリ開発時のアセット制作を行い、実務品質のポートフォリオを構築します。"
  },
  {
    key: "app",
    label: "アプリ",
    tint: "#10b981",
    icon: "app",
    title: "アプリエンジニア",
    img: courseImg06,
    summary:
      "Webアプリと Unity によるネイティブアプリのどちらかを選んで学べるコースです。スマホ/タブレット/PCはもちろん、アーケード向け作品の開発にも挑戦できます。",
    skills: ["HTML/CSS/JavaScript", "TypeScript", "React / Next.js", "API設計 / 認証", "Unity / C#", "入力システム / 物理 / アニメーション", "ビルド / ストア公開 / デプロイ"],
    careers: ["HTML/CSS/JavaScript", "TypeScript", "React / Next.js", "API設計 / 認証", "Unity / C#", "入力システム / 物理 / アニメーション", "ビルド / ストア公開 / デプロイ"],
    features: ["設計/実装/運用の実務", "パフォーマンス最適化", "セキュリティ基礎", "クラウド活用"],
    point: "チーム開発で本番運用を想定したWebアプリまたはネイティブアプリアプリを構築します。"
  }
];

export default function StudentCourseDetailSection() {
  const [active, setActive] = useState(COURSES[0].key);
  const course = COURSES.find(c => c.key === active);

  return (
    <div className="course" aria-labelledby="course-title">
      <div className="course__head">
        <h2 id="course-title" className="course__title">コース内容</h2>
        <p className="course__sub">6つの専門コースから選んで、あなたの未来を切り開こう</p>
      </div>

      {/* タブ */}
      <div className="courseTabs">
        {COURSES.map(c => (
          <button
            key={c.key}
            type="button"
            className={`courseTab ${active === c.key ? "is-active" : ""}`}
            onClick={() => setActive(c.key)}
            style={{ "--tint": c.tint }}
          >
            <span className="courseTab__icon">
              <Icon name={c.icon} />
            </span>
            <span className="courseTab__label">{c.label}</span>
          </button>
        ))}
      </div>

      {/* 2カラム */}
      <div className="course__grid">
        {/* 左カラム */}
        <div className="courseLeft">
          <div className="courseLeft__imgWrap">
            <span className="courseLeft__badge" style={{ background: course.tint || COURSES[0].tint }}>
              <Icon name={course.badgeIcon ?? course.icon} />
            </span>
            <img src={course.img} alt={course.title} className="courseLeft__img" loading="lazy" />
          </div>

          <h3 className="courseLeft__title">{course.title}</h3>
          <p className="courseLeft__summary">{course.summary}</p>

		  <h4 className="skills__title">習得スキル</h4>
          <div className="chipGroup">
            {course.skills.map((s, i) => (
              <span className="chip" key={i}>{s}</span>
            ))}
          </div>

          <div className="career">
            <h4 className="career__title">目指せるキャリア</h4>
            <ul className="career__list">
              {course.careers.map((c, i) => (
                <li key={i}><Icon name="check" /> {c}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* 右カラム */}
        <aside className="courseRight">
          <h4 className="courseRight__title"><Icon name="star" /> コース特徴</h4>
          <ul className="featureList">
            {course.features.map((f, i) => (
              <li key={i}><Icon name="leaf" /> {f}</li>
            ))}
          </ul>

          <div className="coursePoint">
            <p className="coursePoint__lead"><Icon name="bulb" /> このコースのポイント</p>
            <p className="coursePoint__text">{course.point}</p>
          </div>

          <div 
		  	className="btn scd--primary"
			onClick={() => window.open('https://forms.gle/cEmeaFZNhn2M1JUY7', '_blank', 'noopener,noreferrer')}
		  >
			このコースに申し込む
		  </div>
          <div 
		  	className="btn btn--ghost"
			onClick={() => window.open('https://forms.gle/E2yqT7AhhSoy6x6o9', '_blank', 'noopener,noreferrer')}
			>
				詳細資料を請求
			</div>
        </aside>
      </div>
    </div>
  );
}

// ---- 内製アイコン ----
function Icon({ name }) {
  const c = "currentColor";
  switch (name) {
	case "app":
	  return <svg width="1em" height="1em" viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="2" width="10" height="20" rx="2" ry="2" fill="none" stroke={c} strokeWidth="2"/><circle cx="12" cy="18" r="1.2" fill={c}/></svg>;
	case "spark":
	  return <svg width="1em" height="1em" viewBox="0 0 24 24" aria-hidden="true"> <path fill={c} d="M12 2l1.8 4.6L18 8.5l-4.2 1.5L12 14l-1.8-4-4.2-1.5l4.2-1.9L12 2Z"/> <path fill={c} d="M6 16l1 2.6L9.5 20L7 20.9L6 23L5 20.9L2.5 20L5 18.6L6 16Zm12-2l1.4 3.4L23 18l-3.6 1.3L18 23l-1.4-3.7L13 18l3.6-.6L18 14Z"/></svg>;
    case "ai":
      return <svg width="1.3em" height="1.3em" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 8c-1.3-1.5-3.6-1.1-4.4.5c-.4.9-.3 1.8 0 2.5C6.5 11.6 6 12.6 6 13.8c0 1.6 1.3 2.7 2.8 2.7H12V8z"/>
            <path d="M12 8c1.3-1.5 3.6-1.1 4.4.5c.4.9.3 1.8 0 2.5c1.1.6 1.6 1.6 1.6 2.8c0 1.6-1.3 2.7-2.8 2.7H12V8z"/>
            <path d="M9.6 10.6c.6.3 1 .9 1 1.6M8.8 13.1c.6.2.9.6.9 1.1"/>
            <path d="M14.4 10.6c-.6.3-1 .9-1 1.6M15.2 13.1c-.6.2-.9.6-.9 1.1"/>
          </g>
        </svg>;
    case "chart":
      return <svg width="1em" height="1em" viewBox="0 0 24 24"><path fill={c} d="M3 3h2v18H3zm4 10h2v8H7zm4-6h2v14h-2zm4 4h2v10h-2zm4-8h2v18h-2z"/></svg>;
    case "gamepad":
      return  <svg width="1em" height="1em" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 9h12a4 4 0 0 1 0 8h-1l-2-2H9l-2 2H6a4 4 0 0 1 0-8Z"/>
            <path d="M9 12h-2v2m0-2v-2m0 2h2"/>  {/* D-pad */}
            <circle cx="16.8" cy="12.8" r="1"/> {/* A */}
            <circle cx="18.8" cy="14.2" r="1"/> {/* B */}
          </g>
        </svg>
;
    case "pen":
      return <svg width="18" height="18" viewBox="0 0 24 24"><path fill={c} d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25Zm14.71-9.04a1 1 0 0 0 0-1.41l-1.5-1.5a1 1 0 1 0-1.41 1.41l1.5 1.5a1 1 0 0 0 1.41 0Z"/></svg>;
    case "web":
      return <svg width="18" height="18" viewBox="0 0 24 24"><path fill={c} d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm0 2a8 8 0 0 1 7.75 6H4.25A8 8 0 0 1 12 4Zm0 16a8 8 0 0 1-7.75-6h15.5A8 8 0 0 1 12 20Z"/></svg>;
    case "team":
      return <svg width="18" height="18" viewBox="0 0 24 24"><path fill={c} d="M12 12a4 4 0 1 0-4-4a4 4 0 0 0 4 4Zm0 2c-4 0-8 2-8 5v1h16v-1c0-3-4-5-8-5Z"/></svg>;
    case "check":
      return <svg width="16" height="16" viewBox="0 0 24 24"><path fill={c} d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>;
    case "star":
      return <svg width="18" height="18" viewBox="0 0 24 24"><path fill={c} d="m12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63L2 9.24l5.46 4.73L5.82 21z"/></svg>;
    case "leaf":
      return <svg width="16" height="16" viewBox="0 0 24 24"><path fill={c} d="M5 21q.95-4.05 3.9-6.7Q11.75 11.65 16 11q-.65 4.25-3.3 7.1Q10.05 21 6 22q-.4 0-.7-.3T5 21Zm12-17q2.075 0 3.538 1.463Q22 6.925 22 9q0 4.025-2.7 6.863Q16.6 18.7 12 20q1.3-2.675 2.4-4.663Q15.5 13.35 16 11q-2.35.5-4.35 1.6Q9.65 13.7 8 15q-.35-4.6 2.137-7.8Q12.625 4 17 4Z"/></svg>;
    case "bulb":
      return <svg width="16" height="16" viewBox="0 0 24 24"><path fill={c} d="M9 21h6v-1H9v1Zm3-18a7 7 0 0 0-4 12.9V18h8v-2.1A7 7 0 0 0 12 3Z"/></svg>;
	case "palette":
      return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3c-5 0-9 3.6-9 8c0 2.8 2.2 3 4 3h1a2 2 0 0 1 2 2a3 3 0 0 0 3 3c3.9 0 7-3.1 7-7c0-4.4-4-9-8-9Z"/>
          </g>
          {/* 絵の具の滴は白塗り */}
          <circle cx="8.5"  cy="8.7" r="1.2" fill={c}/>
          <circle cx="11.7" cy="6.7" r="1.2" fill={c}/>
          <circle cx="14.8" cy="8.7" r="1.2" fill={c}/>
          <circle cx="13.6" cy="11.6" r="1.2" fill={c}/>
        </svg>
      );
    default:
      return null;
  }
}
